import { render, staticRenderFns } from "./MainDecisions.vue?vue&type=template&id=2ee7d692&scoped=true"
import script from "./MainDecisions.vue?vue&type=script&lang=js"
export * from "./MainDecisions.vue?vue&type=script&lang=js"
import style0 from "./MainDecisions.vue?vue&type=style&index=0&id=2ee7d692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7d692",
  null
  
)

export default component.exports